import LinkHandler from './LinkHandler';

export default LinkHandler;
